import { GoogleMap, InfoWindowF, MarkerF,MarkerClustererF, Polygon, useLoadScript } from "@react-google-maps/api";
import React, { useCallback, useEffect, useMemo, useState,useRef } from "react";
import style from "./Map.module.css";
import IMAGES from "../../assets/images/images";
import { Popover } from 'react-tiny-popover'
import { Loader } from "../loader/Loader";
import { LIVE_SERVICE_STATUS } from "../../utils/constants/serviceConstants";
import { customGroupBy } from "../../utils/arrayUtils";

const CountryMap = ({ country, marker, apiKey }) => {
    const [coordinates, setCoordinates] = useState([]);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: apiKey,
    });
    useEffect(() => {
        const getCountryCoordinates = async () => {
            try {
                const response = await fetch(
                    `https://maps.googleapis.com/maps/api/geocode/json?address=${country}&key=${apiKey}`
                );

                if (!response.ok) {
                    //console.log("Failed");
                } else {
                    const data = await response.json();
                    const geometry = data?.results[0].geometry;
                    if (geometry && geometry.bounds) {
                        const bounds = geometry.bounds;
                        const northeast = bounds.northeast;
                        const southwest = bounds.southwest;
                        const countryOutline = [
                            { lat: northeast.lat, lng: southwest.lng },
                            { lat: northeast.lat, lng: northeast.lng },
                            { lat: southwest.lat, lng: northeast.lng },
                            { lat: southwest.lat, lng: southwest.lng },
                        ]
                        setCoordinates(countryOutline);
                    }

                }

            } catch {
                //console.log("Failed");
            }
        }
        getCountryCoordinates();
    }, [country, marker, apiKey]);
    return (
        <>
            {!isLoaded ? (
                <h1>Loading...</h1>
            ) : (
                <div className={{ "height": "100px", "width": "200px" }}>
                    <GoogleMap
                        mapContainerClassName={{ "height": "100px", "width": "200px" }}
                        center={{ lat: 10, lng: 10 }}
                        zoom={0}
                    >
                        {
                            coordinates.length && (
                                <Polygon
                                    path={coordinates}
                                    options={{
                                        strokeColor: '#FF0000',
                                        strokeOpacity: 1,
                                        strokeWeight: 2,
                                        fillColor: '#FF0000',
                                        fillOpacity: 0,
                                    }}
                                />
                            )
                        }
                    </GoogleMap>
                </div>
            )
            }
        </>
    )
}

const TooltipContent = ({ closeTooltip, infoWindowId,showMyConnectivity, ...props }) => {
    const [tooltipPosition, setTooltipPosition] = useState("");
    const [openIndexDiv, setOpenIndexDiv] = useState(-1);
    useEffect(() => {
        let data = JSON.parse(infoWindowId?.latLong);
        if (Math.sign(Number(data.lng)) == 1) {
            setTooltipPosition("left");
        } else {
            setTooltipPosition("right")
        }
    }, [infoWindowId])

    let rawData =infoWindowId?.customers?.length ? infoWindowId.customers:[]
    const groupByCustomer= customGroupBy(rawData,'cp_name')

    const toggleDiv = (index) => {
        setOpenIndexDiv(prevIndex => (prevIndex === index ? -1 : index));
    }

    return (
        // <div className={tooltipPosition === "left" ? `${style.popoverContainerLeft}` : `${style.popoverContainerRight}`} style={{}}>
            <div className={style.popoverContainerRightTop}>
            <div className={style.closeIconContainer}>
                <div>
                    <img className={style.close} src={IMAGES.close} onClick={closeTooltip} />
                </div>
    </div>

            <div className={style.popoverHeader}>
                <div>
                    <img className={style.headerIcon} src={showMyConnectivity && infoWindowId?.isAvailedService? IMAGES.availedTierIcon : infoWindowId.marker} />
                </div>
                <div>
                    <div className={style.headerTitle}>{infoWindowId?.city}</div>
                    <div className={style.headerSubTitle}>{infoWindowId?.country}</div>
                </div>
            </div>
            <div className={style.fieldContainer}>
                <div className={style.fieldLabel}>Location</div>
                <div className={style.fieldvalue}>{infoWindowId?.location}</div>
            </div>
            <div className={style.fieldContainer}>
                <div className={style.fieldLabel}>Host name</div>
                <div className={style.fieldvalue}>{infoWindowId?.hostName}</div>
            </div>
            <div>
                {
                    infoWindowId?.customers ?
                        <div>
                            <div className={style.hrLine}></div>
                            <div className={style.customerSection}>Customer list</div>
                            <div className={style.collapsibleListScroll}>
                                {
                                    infoWindowId?.customers.length ?
                                    (Object.keys(groupByCustomer).sort().map((key, index) => {
                                        return (
                                            <div key={index} className={style.collapsibleList}>
                                                <div className={style.collapsibleHeader} onClick={() => toggleDiv(index)}>
                                                    <div className={style.collapsibleHeaderTitle}>
                                                        {key}
                                                    </div>
                                                    <div className={style.collapsibleHeaderIcon}>
                                                        <img src={openIndexDiv === index ? IMAGES.chevronOpen : IMAGES.chevronClose} />
                                                    </div>
                                                </div>
                                                <div className={openIndexDiv === index ? style.showcollapsibleContent : style.hidecollapsibleContent}>
                                                {
                                                    groupByCustomer[key].map((item,itemIndex) => {
                                                        return (
                                                            <div key={itemIndex} className={ style.itemContainer}>
                                                                <div className={style.showcollapsibleContentItem1}>
                                                                    {item?.ipx_service?.toUpperCase()}
                                                                </div>
                                                                <div className={parseStatus(item?.bgp_status) === LIVE_SERVICE_STATUS.Live ? `${style.liveService} ${style.showcollapsibleContentItem2}` : `${style.shutdownService} ${style.showcollapsibleContentItem2}`}>
                                                                    {parseStatus(item?.bgp_status)}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                </div>
                                            </div>
                                        )
                                    })
                                )
                                :
                                    <div className={style.noDataMsg}>No Data.</div>
                                }
                            </div>

                        </div> : <></>
                }
            </div>
        </div>
    )
}

const parseStatus=(status)=>{
    let _newStatus=''
        if(status==LIVE_SERVICE_STATUS.No_Shutdown){
            _newStatus=LIVE_SERVICE_STATUS.Live 
        }else if(status==LIVE_SERVICE_STATUS.Shutdown){
            _newStatus=LIVE_SERVICE_STATUS.Shutdown 
        }
    return _newStatus;
}
const HoverTooltipContent = ({ data,clustercount,...props }) => {
    return (
        <div className={style.hoverTooltipContainer}>
            <div className={style.popoverTitle}>{data?.city}</div>
            {clustercount&&(
                <div className={style.popoverTitle}>{data?.length} PoPs</div>
            )}
        </div>
    )
}

export const Map = ({ markers,showMyConnectivity, ...props }) => {
    const [hoverMarkerData, setHoverMarkerData] = useState(null);
    const [infoWindowId, setInfoWindowId] = useState(null);
    const [center, setCenter] = useState({lat: 45, lng: 10});
    const [hoverClusterData, setHoverClusterData] = useState(null);
    const clustererRef = useRef(null);
    // Default center if no markers
    // const defaultCenter = useMemo(() => ({ lat: 45, lng: 10 }), []);
    
    const [markerSize, setMarkerSize] = useState(20);
    // const defaultZoom=2;
    const getAdjustedZoom = () => {
        const baseZoom = 2; // Default zoom for 150%
        const dpr = window.devicePixelRatio || 1; // Detect scaling
        const width = window.innerWidth; // Detect screen width
        let zoom;
        // DPI-based adjustments
        if (dpr >= 1.75) zoom = baseZoom - 0.5;
        else if (dpr >= 1.5) zoom = baseZoom;
        else if (dpr >= 1.25) zoom = baseZoom + 0.5;
        else if (dpr === 1) zoom = baseZoom + 1;
        else zoom = baseZoom;
        //Extra tweak for very large screens
        if (width > 1920) zoom -= 1; // Zoom out slightly on ultra-wide screens

        return zoom;
    };
    const defaultZoom = getAdjustedZoom();

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    });
    const restrictedCoordinate = {
       /* north: 85,
        south: -180,
        west: -85,
        east: 110,*/
      // north: 85, south: -85, west: -179.99, east: 179.999
      north: 85, south: -85, west: -180, east: 180
    };

   const handleMarkerMouseOver = (item) => {
         setHoverMarkerData(item)
    }
    const handleMarkerMouseOut = () => {
        setHoverMarkerData(null)
    }
    
    const showTooltip = (item) => {
        setInfoWindowId(item);
    }
    const closeTooltip = () => {
        setInfoWindowId(null);
    }

    const getMarkerScale = (hoverMarkerData, infoWindowId, item, isAvailedService, showMyConnectivity) => {
        switch (true) {
            // my connnectivity default size
            case (showMyConnectivity && isAvailedService && hoverMarkerData?.id != item.id && infoWindowId?.id != item.id):
                return new window.google.maps.Size(10+markerSize, 10+markerSize);
            // my connnectivity on hover or click size
            case (showMyConnectivity && isAvailedService && (hoverMarkerData?.id === item.id || infoWindowId?.id === item.id)):
                return new window.google.maps.Size(30+markerSize, 30+markerSize);
            // other marker default size
            case (hoverMarkerData?.id != item.id && infoWindowId?.id != item.id):
                return new window.google.maps.Size(markerSize, markerSize);
            // other marker  on hover or click size
            case (hoverMarkerData?.id === item.id || infoWindowId?.id === item.id):
                return new window.google.maps.Size(20+markerSize, 20+markerSize);
            default:
                return new window.google.maps.Size(markerSize, markerSize);
        }
    }

    const onLoad = useCallback((map) => { 
        map.addListener('zoom_changed', () => { 
            const zoomLevel = map.getZoom(); 
            const newSize = Math.max(20, zoomLevel * 5);
            setMarkerSize(newSize);
            setHoverClusterData(null)
        }); 
        map.addListener("idle", () => setHoverClusterData(null))
    }, []);
  
    // Compute dynamic center based on markers
    // const center = useMemo(() => {
    //   if (!markers || markers.length === 0) return defaultCenter;
  
    //   const points = [];
    //   for (const item of markers) {
    //     try {
    //       const parsed = typeof item?.latLong === "string" ? JSON.parse(item.latLong) : item?.latLong;
    //       const lat = Number(parsed?.lat);
    //       const lng = Number(parsed?.lng);
    //       if (Number.isFinite(lat) && Number.isFinite(lng)) {
    //         points.push({ lat, lng });
    //       }
    //     } catch {
    //       // ignore parse errors
    //     }
    //   }
  
    //   if (points.length === 0) return defaultCenter;
  
    //   const avgLat = points.reduce((sum, p) => sum + p.lat, 0) / points.length;
    //   const avgLng = points.reduce((sum, p) => sum + p.lng, 0) / points.length;
    //   return { lat: avgLat, lng: avgLng };
    // }, [markers, defaultCenter]);
    const calculator = useCallback((clusterMarkers) => {
        const markerData = clusterMarkers?.map((m) => m.get("data")) || [];
        const anyTrue = markerData.some((d) => d?.isAvailedService === true);
        const anyFalse = markerData.some((d) => d?.isAvailedService !== true);
        const allTrue = markerData.length > 0 &&markerData.every((d) => d?.isAvailedService === true);
        const allFalseOrUndefined = markerData.length > 0 &&markerData.every((d) => d?.isAvailedService !== true);
        let index = null;
        if (showMyConnectivity) {
        if (allTrue) index = 2;
        else if (anyTrue && anyFalse) index = 1;
        else if (allFalseOrUndefined) index = 3;
        } else {
        index = 3;
        }
        return { text: "", index };
    },[showMyConnectivity]);
    
    const clustererOptions = useMemo(() => ({
        minimumClusterSize: 2,
        zoomOnClick: true,
        averageCenter: true,
        styles: [
            { url: IMAGES.popsIcon, height: 39, width: 65 },
            { url: IMAGES.myconnectivityclustor, height: 30, width: 30 },
            { url: IMAGES.vfipxclustor, height: 30, width: 30 },
        ],
        calculator,
    }), [showMyConnectivity]);

    useEffect(() => {
        if (!clustererRef.current) return;
        // Update calculator directly
        clustererRef.current.setCalculator(calculator);
        setCenter({lat: 45, lng: 10})
        clustererRef.current.repaint();
    }, [showMyConnectivity]);

    const renderedMarkers = useMemo(() => {
      if (!markers || markers.length === 0) return null;
  
      return (
        <MarkerClustererF
        options={clustererOptions}
        onLoad={(clusterer) => {
            clustererRef.current = clusterer;
            clusterer.addListener("mouseover", (cluster) => {
            const markers = cluster.getMarkers();
            const markerData = markers.map(m => m.get("data"));
            setHoverClusterData({position: cluster.getCenter(),data: markerData});});
            clusterer.addListener("mouseout", () => setHoverClusterData(null));
            clusterer.addListener("click", () => {setHoverClusterData(null);});
        }}
        >
          {(clusterer) =>
            markers.map((item, index) => {
              const data = JSON.parse(item?.latLong);
              const isAvailedService = !!item?.isAvailedService;
  
              return (
                <MarkerF
                  key={item?.id ?? index}
                  clusterer={clusterer}
                  position={{
                    lat: Number(data?.lat),
                    lng: Number(data?.lng),
                  }}
                  onLoad={(marker) => marker.set("data", item)}
                  onMouseOver={() => handleMarkerMouseOver(item)}
                  onMouseOut={() => handleMarkerMouseOut()}
                  onClick={() => showTooltip(item)}
                  icon={{
                    url:
                      showMyConnectivity && isAvailedService
                        ? IMAGES.availedTierIcon
                        : item.marker,
                    scaledSize: getMarkerScale(
                      hoverMarkerData,
                      infoWindowId,
                      item,
                      isAvailedService,
                      showMyConnectivity
                    ),
                  }}
                >
                  {hoverMarkerData?.id === item.id && (
                    <InfoWindowF>
                      <HoverTooltipContent data={hoverMarkerData} />
                    </InfoWindowF>
                  )}
                </MarkerF>
              );
            })
          }
        </MarkerClustererF>
      );
    }, [markers, clustererOptions, hoverMarkerData, infoWindowId, markerSize,showMyConnectivity]);
  
    return (
        <div className={ `${style.App}`}>
            {!isLoaded ? (
                <Loader/>
            ) : (
                <GoogleMap
                    mapContainerClassName={ `${style.mapContainer}`}
                    center={ center }
                    zoom={defaultZoom}
                    onLoad={onLoad}
                    options={
                        {
                          gestureHandling: "greedy",  // added to remove overaly scroll to zoom the map
                            disableDefaultUI: true,
                            zoomControl:true,
                            zoomControlOptions: {
                                position:  window.google.maps.ControlPosition.LEFT_TOP,
                            },
                            restriction: {
                                latLngBounds: restrictedCoordinate,
                                strictBounds: false,
                            },
                            styles: [
                               /* {
                                    featureType: "all",
                                    elementType: "all",
                                    stylers: [
                                        { color: "#FFFFFF" }
                                    ]
                                },*/
                                {
                                    featureType: "all",
                                    elementType: "geometry",
                                    stylers: [
                                        { color: "#373737" }
                                    ]
                                },
                                /*--------Water----------*/
                                {
                                    featureType: "water",
                                    elementType: "all",
                                    stylers: [{ color: "#25282B" }]
                                },
                                {
                                    featureType: "water",
                                    elementType: "labels.text.fill",
                                    stylers: [
                                        { color: "#ffffff" }
                                    ]
                                },
                                {
                                    featureType: "water",
                                    elementType: "labels.text.stroke",
                                    stylers: [{ visibility: "off"  }]
                                },
                                /*----Hide all line --*/
                                {
                                    featureType: "administrative", 
                                    elementType: "all",    
                                    stylers: [{ visibility: "off" }]
                                },
                                {
                                    featureType: "administrative.country", 
                                    elementType: "geometry.stroke",    
                                    stylers: [{ visibility: "on" },
                                    { color: "#25282B"  }
                                ]
                                },
                                /*---CSS for country city fonts----*/
                                {
                                    featureType: "administrative.country",
                                    elementType: "labels.text",
                                    stylers: [{ visibility: "on" }]
                                },
                                {
                                    featureType: "administrative.province",
                                    elementType: "labels.text",
                                    stylers: [{ visibility: "on" }]
                                },
                                {
                                    featureType: "administrative.locality",
                                    elementType: "labels.text",
                                    stylers: [{ visibility: "on" }]
                                },
                                {
                                    featureType: "administrative",
                                    elementType: "labels.text.fill",
                                    stylers: [{ color: "#ffffff" }]
                                },
                                {
                                    featureType: "administrative",
                                    elementType: "labels.text.stroke",
                                    stylers: [{ visibility: "off"  }]
                                },
                                /*---end----*/
                                
                                {
                                    featureType: "landscape.man_made",
                                    elementType: "all",
                                    stylers: [
                                        { color: "#606466" }
                                    ]
                                },
                                {
                                    featureType: "landscape.natural.landcover",
                                    elementType: "all",
                                    stylers: [
                                        { color: "#606466" }
                                    ]
                                },
                                {
                                    featureType: "road",
                                    stylers: [
                                        { visibility: "off" }
                                    ]
                                },
                                {
                                    featureType: "poi",
                                    stylers: [
                                        { visibility: "off" }
                                    ]
                                }

                            ],
                            minZoom: defaultZoom,
                        }
                    }
                >
               {markers?.length > 0 ? renderedMarkers : null }
                {hoverClusterData?.data && (
                    <InfoWindowF position={hoverClusterData.position}>
                    <HoverTooltipContent clustercount={true} data={hoverClusterData.data} />
                    </InfoWindowF>
                )}


                    {/* {
                        markers.map((item, index) => {
                            let data = JSON.parse(item?.latLong);
                            let isAvailedService = item?.isAvailedService ? true : false
                            let hasCustomerField = item?.customers ? true : false  // true only for internal user
                            return (
                                <Marker
                                    key={index}
                                    onMouseOver={() => handleMarkerMouseOver(item)}
                                    onMouseOut={() => handleMarkerMouseOut()}
                                    onClick={()=>showTooltip(item)}
                                    position={{ lat: Number(data?.lat), lng: Number(data?.lng) }}
                                    icon={{
                                        url: isAvailedService && infoWindowId?.id  === item.id ?
                                            IMAGES.companyPopsHover : isAvailedService && infoWindowId?.id  !== item.id ? IMAGES.companyPops :
                                                !isAvailedService && infoWindowId?.id  === item.id ? IMAGES.vfPopsHover : IMAGES.vfPops,
                                        //scaledSize: new window.google.maps.Size(10, 10), // scaled size
                                       // origin: new window.google.maps.Point(0,0), // origin
                                       // anchor: new window. google.maps.Point(0, 0) // anchor
                                        
                                    }}
                                    icon={{
                                        url: showMyConnectivity && isAvailedService?IMAGES.availedTierIcon:item.marker,
                                        scaledSize: getMarkerScale(hoverMarkerData,infoWindowId,item,isAvailedService,showMyConnectivity)
                                        //scaledSize: hoverMarkerData?.id === item.id || infoWindowId?.id === item.id ? new window.google.maps.Size(40, 40) : new window.google.maps.Size(20, 20)
                                    }}
                                >
                                    {
                                        (hoverMarkerData?.id === item.id) &&
                                        (
                                            <InfoWindowF >
                                                <HoverTooltipContent
                                                    data={hoverMarkerData} />
                                            </InfoWindowF>
                                        )

                                    }
                                </Marker>
                            )
                        })
                      } */
                    }
                    {/*
                        (infoWindowId) && (
                            <Popover
                            isOpen={true}
                                reposition={true}
                                transform={{ top: 20, left: 20 }}
                                transformMode='relative'
                                positions={["center"]} // preferred positions by priority
                                content={
                                    <TooltipContent 
                                    closeTooltip={closeTooltip}
                                    infoWindowId={infoWindowId}/>
                                }
                          >
                                <></>
                            </Popover>)

                            */}

                </GoogleMap>
            )}
            {
                (infoWindowId) &&
                (<div>
                    <TooltipContent
                        closeTooltip={closeTooltip}
                        infoWindowId={infoWindowId}
                        showMyConnectivity={showMyConnectivity}/>
                </div>)

            }

        </div>
    );
};

